export const getCSSVar = (variable: string) => {
  return window.getComputedStyle(document.documentElement).getPropertyValue(variable);
};
